"use strict";
var ArrayBufferViewCore = require("../internals/array-buffer-view-core");
var toLength = require("../internals/to-length");
var toAbsoluteIndex = require("../internals/to-absolute-index");
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod("subarray", function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = getTypedArrayConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === void 0 ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});
